"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChatDraftMessage = void 0;
var _react = require("react");
var _reactSdk = require("@100mslive/react-sdk");
var _constants = require("../../common/constants");
var useChatDraftMessage = function useChatDraftMessage() {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var chatDraftMessage = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.chatDraft));
  if (chatDraftMessage === undefined || chatDraftMessage === null) {
    chatDraftMessage = "";
  }
  var setDraftMessage = (0, _react.useCallback)(function (message) {
    hmsActions.setAppData(_constants.APP_DATA.chatDraft, message, true);
  }, [hmsActions]);
  return [chatDraftMessage, setDraftMessage];
};
exports.useChatDraftMessage = useChatDraftMessage;